import { Entity, Field } from 'typegraph';

@Entity({ update: "enrollmentUpdate" })
export class SeatAssignment {
    @Field()
	id: number;

}


// WEBPACK FOOTER //
// ./src/panels/checkout/entities/SeatAssignment.ts